module.exports = __webpack_public_path__ + "static/media/8.1ab37ee9.JPG";